module.exports = __webpack_public_path__ + "img/toplogo.910ec08a.png";